import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import closeIcon from '../../../img/icon-close-x.png'
import { setDialog } from '../../actions/navigation'
import { modulo } from '../../utils'

const Modal = ({
    children,
    closeModal,
    closeLabel = null, // optional label for close button at the bottom of the modal
    escapable = true // false if the only way to close the modal is the closeButton at the bottom
}) => {
    const modalRef = useRef()

    const onKeyDown = e => {
        if (!modalRef.current) {
            return
        }

        if (e.code === 'Escape') {
            closeModal()
        }

        if (e.code === 'Tab') {
            e.preventDefault()
            const selector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            const focusableElements = Array.from(modalRef.current.querySelectorAll(selector))
            const numberOfElements = focusableElements.length
            const focusedIndex = focusableElements.indexOf(document.activeElement)

            if (e.shiftKey) {
                // focus on previous element
                focusableElements[modulo(focusedIndex - 1, numberOfElements)].focus()
            } else {
                // focus on next element
                focusableElements[modulo(focusedIndex + 1, numberOfElements)].focus()
            }
        }
    }

    useEffect(() => {
        if (modalRef.current) {
            modalRef.current.focus()
        }

        document.addEventListener('keydown', onKeyDown)
        return () => document.removeEventListener('keydown', onKeyDown)
    }, [])

    let closeButton = null
    if (closeLabel) {
        closeButton = (
            <button type="button" className="button is-primary" onClick={closeModal}>
                {closeLabel}
            </button>
        )
    }

    return ReactDOM.createPortal(
        <div className="modal is-active">
            <div className="modal-background" onClick={escapable ? closeModal : null} />
            <div className="modal-window" ref={modalRef} tabIndex={-1}>
                {escapable && (
                    <header className="close-header">
                        <button className="close" type="button" onClick={closeModal} aria-label="close">
                            <img src={closeIcon} alt="Close" />
                        </button>
                    </header>
                )}
                <section className="modal-body">
                    <div
                        className="content"
                        aria-describedby="modalDescription"
                        role="dialog"
                        aria-modal="true"
                        aria-live="polite"
                    >
                        <p className="visually-hidden" id="modalDescription">
                            This is a dialog window which overlays the main content of the page. Press escape to exit.
                        </p>
                        {children}
                        {closeButton}
                    </div>
                </section>
            </div>
        </div>,
        document.getElementById('modal')
    )
}

export default connect(null, dispatch => ({
    closeModal: () => dispatch(setDialog(''))
}))(Modal)
